module.exports = __webpack_public_path__ + "static/media/ButtonBase.43b628c6.png";